export default __webpack_public_path__ + "static/media/icons-system-chevron-down.35496e20.svg";